import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { resolveReferralCode } from "../lib/api";

/**
 * ReferralRedirect — `/r/{code}` lands here, resolves the code (best-effort),
 * then sends the visitor to /onboard-simple?ref={code} so the signup form
 * captures attribution. If the code is invalid we still redirect (graceful)
 * so the URL is shareable without panic.
 */
const ReferralRedirect = () => {
  const { code } = useParams();
  const upper = (code || "").toUpperCase().trim();
  useEffect(() => {
    // Fire & forget resolve (we don't need to wait — the onboard form does final validation)
    if (upper) resolveReferralCode(upper).catch(() => {});
  }, [upper]);
  if (!upper) return <Navigate to="/onboard-simple" replace />;
  return <Navigate to={`/onboard-simple?ref=${encodeURIComponent(upper)}`} replace />;
};

export default ReferralRedirect;
